/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Model96 } from './model96';
import { Model97 } from './model97';


export interface ProductUpdateInput { 
    archived?: boolean;
    createdAt?: string;
    description?: string;
    featured?: boolean;
    fields?: Model96;
    handlingPrice?: number;
    id?: string;
    imageFive?: string;
    imageFour?: string;
    imageOne?: string;
    imageThree?: string;
    imageTwo?: string;
    isRefundable?: boolean;
    locked?: boolean;
    name?: string;
    path?: string;
    price?: number;
    productCategory?: string;
    published?: boolean;
    quantity?: number;
    readOnly?: boolean;
    salePrice?: number;
    shippable?: boolean;
    shippingFree?: boolean;
    skus?: Model97;
    sortOrder?: number;
    taxable?: boolean;
    updatedAt?: string;
    version?: number;
    weight?: number;
}
